document.addEventListener("DOMContentLoaded", ()=>{
    const menu = document.querySelector(".menu");
    const header = document.querySelector("header");
    const navLinks = document.querySelectorAll(".menu a");
    const toTop = document.querySelector("#totop");
    const trigger = document.querySelector(".trigger button");
    let scrolling = false;
    trigger.addEventListener("click", ()=>{
        menu.classList.toggle("open");
    });
    navLinks.forEach((link)=>{
        link.addEventListener("click", (e)=>{
            menu.classList.remove("open");
            navLinks.forEach((otherLink)=>{
                scrolling = true;
                if (otherLink === link) otherLink.classList.add("active");
                else otherLink.classList.remove("active");
            });
        });
    });
    const sections = document.querySelectorAll(".section");
    document.addEventListener("scrollend", ()=>{
        scrolling = false;
    });
    document.addEventListener("scroll", ()=>{
        if (document.documentElement.scrollTop < 72) {
            toTop?.classList.add("hidden");
            header.classList.remove("sticky");
        } else {
            toTop?.classList.remove("hidden");
            header.classList.add("sticky");
        }
        if (scrolling) return;
        let found = false;
        for(let i = sections.length - 1; i >= 0; i--){
            const section = sections[i];
            const rect = section.getBoundingClientRect();
            const id = section.getAttribute("id");
            const a = document.querySelector(`a[href="#${id}"]`);
            if (found) a?.classList.remove("active");
            else {
                if (rect.top < 72) {
                    a?.classList.add("active");
                    found = true;
                } else if (i > 0) a?.classList.remove("active");
            }
        }
    });
});


document.addEventListener("DOMContentLoaded", ()=>{
    const slider = document.querySelector('.slider');
    const sliderBody = document.querySelector('.slider .body');
    const sliderControls = document.querySelectorAll('.slider .controls a');
    let timer;
    function onTimer() {
        if (sliderBody.scrollLeft % sliderBody.clientWidth === 0) sliderBody.scrollTo({
            behavior: 'smooth',
            left: (sliderBody.scrollLeft + sliderBody.clientWidth) % sliderBody.scrollWidth
        });
    }
    function clearTimer() {
        if (timer) clearInterval(timer);
    }
    function resetTimer() {
        clearTimer();
        timer = setInterval(onTimer, 5000);
    }
    slider.addEventListener('mouseenter', clearTimer);
    slider.addEventListener('mouseleave', resetTimer);
    sliderControls.forEach((control)=>{
        control.addEventListener('mousedown', clearTimer);
    });
    sliderBody.addEventListener('scrollend', ()=>{
        const active = sliderBody.scrollLeft / sliderBody.clientWidth;
        for(let i = 0; i < sliderControls.length; i++)if (active === i) sliderControls[i].classList.add('active');
        else sliderControls[i].classList.remove('active');
    });
    resetTimer();
});


document.addEventListener("DOMContentLoaded", ()=>{
    // const PUBLIC = '6e0b4a66c160f5ea07abaeecb87fc087';
    // const PRIVATE = '7b50b89a54f4cfdfd384387226f32d31';
    const form = document.querySelector('.form form');
    const message = document.querySelector('.form .actions .message');
    const inputs = document.querySelectorAll('.form form input, .form form textarea, .form form button');
    form.addEventListener('submit', (e)=>{
        e.preventDefault();
        inputs.forEach((input)=>input.dataset.disabled = "true");
        message.classList.remove('error');
        message.classList.add('info');
        message.textContent = 'Sending message...';
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        fetch('https://submit-form.com/VtnRi4Vnd', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            }
        }).then((response)=>{
            if (response.ok) {
                response.json().then((data)=>{
                    console.log(data);
                });
                message.classList.remove('info');
                message.classList.add('success');
                message.textContent = 'Message sent successfully';
                inputs.forEach((input)=>input.disabled = true);
            } else {
                message.classList.remove('info');
                message.classList.add('error');
                message.textContent = 'Failed to send message';
                inputs.forEach((input)=>input.dataset.disabled = "false");
            }
        }).catch((error)=>{
            message.classList.remove('info');
            message.classList.add('error');
            message.textContent = 'Try again later.';
            inputs.forEach((input)=>input.dataset.disabled = "false");
        });
    });
});




//# sourceMappingURL=index.bd95b450.js.map
